/** @jsxImportSource @emotion/react */
import Image from "next/image";
import { black } from "../../assets/styles/colors";
import Button from "../Button";

import {
  profileContainerStyle,
  profileButtonsStyle,
  profileDetailStyle,
  profileTitleStyle,
  profileEnumListStyle,
  StyledBigImgContainer,
  bigImgStyle,
  StyledProfileDetailsContainer,
} from "./styles";
import { createRef, useRef, useState } from "react";

export default function Profile({ person }) {
  const age = new Date().getFullYear() - person.anneeDeNaissance;

  const [colorsMonotone] = useState({
    actor: "MediumTurquoise",
    people: "gold",
    model: "magenta",
    tv: "magenta",
    fiction: "gold",
    pub: "MediumTurquoise",
  });

  const ref = useRef();

  const generateImage = async () => {
    window.print();
  };

  const bigImg = createRef();
  const handleImgClick = (e) => {
    bigImg.current.src = e.target.src;
    setBitImgToggle(true);
  };
  const [bigImgToggle, setBitImgToggle] = useState(false);
  const handleBigImgClick = () => {
    bigImg.current.src = "";
    setBitImgToggle(false);
  };

  return (
    <section css={profileContainerStyle} ref={ref}>
      <div css={profileButtonsStyle}>
        {/* <Button onClick={generateImage}>Print</Button> */}
        <Button
          href={`mailto:virginie@kaleidoscope-agency.be?subject=More%20information%20about%20${person.number}`}
        >
          More information
        </Button>
      </div>
      <StyledProfileDetailsContainer
        positionImg={person.photoPrincipale.imgPosition}
        id="details"
      >
        <Image
          unoptimized
          src={person.photoPrincipale.url}
          width={420}
          height={700}
          onClick={(e) => handleImgClick(e)}
          id="main-picture"
        />
        <div css={profileDetailStyle}>
          <h1 css={profileTitleStyle} id="title">
            {person.number}
          </h1>
          <p id="subtitle">
            {person.region} - Born in {person.anneeDeNaissance} - {age}y -{" "}
            {person.taille}cm
          </p>

          <div>
            <h2>Type</h2>
            <ul css={profileEnumListStyle}>
              <li
                css={{
                  fontWeight: person.type.includes("Actor") ? 900 : 300,
                  color: person.type.includes("Actor")
                    ? colorsMonotone.actor
                    : "",
                }}
              >
                Actor
              </li>
              <li
                css={{
                  fontWeight: person.type.includes("People") ? 900 : 300,
                  color: person.type.includes("People")
                    ? colorsMonotone.people
                    : "",
                }}
              >
                People
              </li>
              <li
                css={{
                  fontWeight: person.type.includes("Model") ? 900 : 300,
                  color: person.type.includes("Model")
                    ? colorsMonotone.model
                    : "",
                }}
              >
                Model
              </li>
            </ul>
          </div>
          <div>
            <h2>Job</h2>
            <ul css={profileEnumListStyle}>
              <li
                css={{
                  fontWeight: person.job.includes("TV") ? 900 : 300,
                  color: person.job.includes("TV") ? colorsMonotone.tv : "",
                }}
              >
                TV
              </li>
              <li
                css={{
                  fontWeight: person.job.includes("Fiction") ? 900 : 300,
                  color: person.job.includes("Fiction")
                    ? colorsMonotone.fiction
                    : "",
                }}
              >
                Fiction
              </li>
              <li
                css={{
                  fontWeight: person.job.includes("Pub") ? 900 : 300,
                  color: person.job.includes("Pub") ? colorsMonotone.pub : "",
                }}
              >
                Pub
              </li>
            </ul>
          </div>
          <div>
            <h2>Other skills</h2>
            <p>{person.otherSkills}</p>
          </div>
          <div>
            <h2>Like</h2>
            <p>{person.like}</p>
          </div>
          <div>
            <h2>Dislike</h2>
            <p>{person.dislike}</p>
          </div>
        </div>
      </StyledProfileDetailsContainer>
      {/* Big Image on click */}
      <StyledBigImgContainer isOpen={bigImgToggle} onClick={handleBigImgClick}>
        <img css={bigImgStyle} ref={bigImg} />
      </StyledBigImgContainer>
    </section>
  );
}
